import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Snackbar,
  Stack,
  Divider,
  InputAdornment,
  IconButton,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useForm } from "react-hook-form";
import mobileBackground from "../../icons/crm_mobile_login_background.png";
import ib_logo from "../../icons/IB_logo.png";
import ib_logo1 from "../../icons/ABIS_logo.png";
import loginStyles from "./loginStyles.module.css";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import { LoginContext } from "./LoginContext";
import axios from "axios";
import { AUTH_API, GET_AUTH_TOKEN,PUSH_NOTIFICATION_SAVE_FCM_TOKEN } from "../../constants";
import topSplash from "../../icons/top_splash.png";
// import { requestNotificationPermission } from "../../firebase/notification";
import Cookies from "js-cookie";
import { AuthContext } from "./AuthContext";
// import { requestNotificationPermission, setupForegroundNotifications } from "../../services/notification-service";
import { getFCMToken } from "../../Utils/fcm";



const MobileLogin = () => {
  const navigate = useNavigate();
  const { login, isLoggedIn, logout } = useContext(LoginContext);

  const [loading, setLoading] = useState(false);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("");
  const [message, setMessage] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [rememberMe, setRememberMe] = useState(false);

  const handleLogin = async () => {
    setLoading(true);

    const requestBody = {
      EmployeeId: username,
      EmployeePassword: password,
    };

    try {
      const response = await axios.post(AUTH_API, requestBody);

      if (response.data.status == "200") {
        const { employee } = response.data;

        // Detect if the app is running as PWA
        const isPWA =
          window.matchMedia("(display-mode: standalone)").matches ||
          (window.navigator.standalone &&
            window.location.hostname !== "localhost") ||
          document.referrer.includes("android-app://");

        // Detect if the device is a Desktop/Laptop
        const isDesktop = window.innerWidth > 1024; // Consider screens > 1024px as desktops

        // If BDMs (role 2 or 3) try to log in from a desktop, block them
        // if (
        //   (employee.EmployeeRole == 2 || employee.EmployeeRole == 3) &&
        //   isDesktop &&
        //   !isPWA
        // ) {
        //   navigate("/pwa-restricted");
        //   setLoading(false);
        //   return; // Stop execution
        // }

        login(response.data.employee.EmployeeRole, response.data.employee);

        localStorage.setItem("username", username);
        localStorage.setItem("password", password);
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("empRole", response.data.employee.EmployeeRole);
        localStorage.setItem("sessionActive", "true"); // Persist state

        // Store authentication details in HTTP-only secure cookies
        Cookies.set("authToken", response.data.token, {
          expires: 1,
          secure: true,
          sameSite: "Strict",
        });
        Cookies.set("userData", JSON.stringify(response.data.employee), {
          expires: 1,
          secure: true,
          sameSite: "Strict",
        });
        Cookies.set("username", username, {
          expires: 1,
          secure: true,
          sameSite: "Strict",
        });
        Cookies.set("empRole", employee.EmployeeRole, {
          expires: 1,
          secure: true,
          sameSite: "Strict",
        });

        if (rememberMe) {
          Cookies.set("rememberMe", "true", {
            expires: 1,
            secure: true,
            sameSite: "Strict",
          });
        }

        setSeverity("success");
        setMessage("Login Successful!!");
        setOpenSnackbar(true);

        // Fetch the additional AuthToken
        await fetchAuthToken();


            try {
              const fcmToken = await getFCMToken(employee.EmployeeId); // fetch token from Firebase
             if (fcmToken) {
              await axios.post(PUSH_NOTIFICATION_SAVE_FCM_TOKEN, {
              userId: employee.EmployeeId,
              token: fcmToken,
            });
                console.log("FCM token stored successfully");
                // console.log("FCM token stored successfully",fcmToken);
              } else {
               console.log("No FCM token retrieved");
              }
               } catch (err) {
                   console.error("Error saving FCM token:", err);
            }
        
    

        // Initialize Firebase notifications after successful login

        // try {
        //   // Request permission and get token
        //   await requestNotificationPermission();

        //   // Set up handlers for foreground notifications
        //   setupForegroundNotifications();

        //   console.log("Notification setup complete");
        // } catch (notificationError) {
        //   console.error("Error setting up notifications:", notificationError);
        //   // Don't block login flow if notifications fail
        // }

        // Navigate to appropriate page based on role
        if (response.data.employee.EmployeeRole == 6) {
          navigate("/estimateGeneration");
        } else if (
          response.data.employee.EmployeeRole == 2 ||
          response.data.employee.EmployeeRole == 3
        ) {
          if (
            response?.data?.employee?.todayAttendance === null ||
            response?.data?.employee?.todayAttendance === ""
          ) {
            navigate("/bdmtask");
          } else {
            navigate("/bdmtodo");
          }
        } else if (response.data.employee.EmployeeRole === 7) {
          navigate("/hrReport");
        } else if (response.data.employee.EmployeeRole === 500) {
          if (
            response?.data?.employee?.todayAttendance === null ||
            response?.data?.employee?.todayAttendance === ""
          ) {
            navigate("/bdmtask");
          } else {
            navigate("/bdmtodo");
          }
        } else {
          navigate("/dashboard");
        }
      } else {
        // handle invalid credentials or other server messages
        setSeverity("error");
        setMessage(response.data.message || "Login failed");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        setSeverity("error");
        setMessage(error.response.data.message);
        setOpenSnackbar(true);
      } else if (error.request) {
        console.log("Request:", error.request);
        setSeverity("error");
        setMessage("Internal Server Error");
        setOpenSnackbar(true);
      }
    } finally {
      setLoading(false); // Re-enable button and hide loader
    }
  };

  const fetchAuthToken = () => {
    const requestBody = {
      username: "ABIS123",
      password: "ABIS@123",
    };

    axios
      .post(GET_AUTH_TOKEN)
      .then((response) => {
        console.log("AuthToken retrieved:", response.data.token);
        localStorage.setItem("clickToCallToken", response.data.token.idToken); // Save the idToken in local storage
      })
      .catch((error) => {
        console.error("Error fetching AuthToken:", error);
      });
  };

  const handleKeyPress = (e) => {
    // Check if the pressed key is Enter (key code 13)
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  useEffect(() => {
    const savedToken = Cookies.get("authToken");
    const savedUser = Cookies.get("userData");
    const savedRememberMe = Cookies.get("rememberMe");

    // if (savedToken && savedUser && savedRememberMe === "true") {
    //   const userData = JSON.parse(savedUser);
    //   console.log('here', savedUser);
    //   // Set user details without calling API
    //   login(userData.EmployeeRole, userData);

    //   navigate(
    //     userData.EmployeeRole == 6
    //       ? "/estimateGeneration"
    //       : userData.EmployeeRole == 2 || userData.EmployeeRole == 3
    //       ? userData.todayAttendance?.attendanceId
    //         ? "/bdmtodo"
    //         : "/bdmtask"
    //       : "/dashboard"
    //   );

    // }
  }, []);

  // const autoLogin = (savedUsername, savedPassword) => {
  //   setLoading(true);

  //   const requestBody = {
  //     EmployeeId: savedUsername,
  //     EmployeePassword: savedPassword,
  //   };
  //   // navigate('/dashboard');
  //   // Make POST request using Axios
  //   axios
  //     .post(AUTH_API, requestBody)
  //     .then((response) => {
  //       // Handle successful authentication

  //       if (response.data.status == "200") {
  //         const { employee } = response.data;
  //         login(response.data.employee.EmployeeRole, response.data.employee);

  //         localStorage.setItem("username", savedUsername);
  //         localStorage.setItem("password", savedPassword);
  //         localStorage.setItem("authToken", response.data.token);
  //         localStorage.setItem("empRole", response.data.employee.EmployeeRole);
  //         if (rememberMe === true) {
  //           localStorage.setItem("rememberMe", "true");
  //         }

  //         localStorage.setItem("sessionActive", "true"); // Persist state
  //         setSeverity("success");
  //         setMessage("Login Successful!!");
  //         setOpenSnackbar(true);
  //         if (response.data.employee.EmployeeRole == 6) {
  //           navigate("/estimateGeneration");
  //         } else if (
  //           response.data.employee.EmployeeRole == 2 ||
  //           response.data.employee.EmployeeRole == 3
  //         ) {
  //           if (
  //             response?.data?.employee?.todayAttendance === null ||
  //             response?.data?.employee?.todayAttendance === ""
  //           ) {
  //             navigate("/bdmtask");
  //           } else {
  //             navigate("/bdmtodo");
  //           }
  //         } else {
  //           navigate("/dashboard");
  //         }

  //         // Fetch the additional AuthToken
  //         fetchAuthToken();
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       if (error.response) {
  //         setSeverity("error");
  //         setMessage(error.response.data.message);
  //         setOpenSnackbar(true);
  //       } else if (error.request) {
  //         // The request was made but no response was received
  //         console.log("Request:", error.request);
  //         setSeverity("error");
  //         setMessage("Internal Server Error");
  //         setOpenSnackbar(true);
  //       }
  //     })
  //     .finally(() => {
  //       setLoading(false); // Re-enable button and hide loader
  //     });
  // };

  return (
    <Container
      maxWidth={false}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        position: "relative", // Ensure relative positioning for absolute elements
        pb: 8, // Add bottom padding to prevent form overlap with the image
      }}
    >
      {/* Image at the top */}
      <Box
        sx={{
          position: "absolute",
          top: -13, // Adjust the top value based on screen size
          left: "50%",
          transform: "translateX(-50%)",
          width: "104%",
          zIndex: 1, // Ensure this is above other content
        }}
      >
        <img
          src={topSplash} // Replace with your image path
          alt="Top Illustration"
          style={{ width: "100%", objectFit: "contain" }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          placeContent: "center",
          height: "5rem",
          zIndex: 2, // Ensure the logo is above the image
          mt: { xs: "25%", sm: 0 }, // Add margin-top for smaller screens to avoid overlap
        }}
      >
        <img
          src={ib_logo}
          loading="lazy"
          alt="onCall"
          style={{ width: "5rem" }}
        />
        <Divider
          orientation="vertical"
          variant="middle"
          className={`px-2 ${loginStyles.logo_divider}`}
          flexItem
        />
        <img
          src={ib_logo1}
          loading="lazy"
          alt="onCall"
          style={{
            height: "3.4rem",
            marginTop: "9px",
            width: "7rem",
            paddingRight: "0.5rem",
            paddingLeft: "0.5rem",
          }}
        />
      </Box>

      <Box sx={{ textAlign: "center", mb: 3, mt: 1 }}>
        <Typography
          variant="h5"
          fontWeight="bold"
          className={`${loginStyles.login_heading}`}
        >
          Welcome to{" "}
        </Typography>
        <Typography
          variant="h6"
          fontWeight="bold"
          className={`${loginStyles.login_heading}`}
        >
          ABIS CRM
        </Typography>
      </Box>

      <form style={{ width: "100%", mt: "10px" }}>
        {/* <Typography variant="body1" sx={{ fontWeight: "bold", mb: 0.5 }}>
          Employee Id
        </Typography> */}

        <TextField
          placeholder="Employee Id"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          variant="outlined"
          fullWidth
          size="small"
          sx={{
            "& .MuiInputBase-root": {
              borderRadius: 3,
            },
            zIndex: 2,
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={`-ml-1`}>
                <PersonIcon className={`${loginStyles.icon_size}`} />
              </InputAdornment>
            ),
          }}
        />

        {/* Password Field */}
        {/* <Typography variant="body1" sx={{ fontWeight: "bold", mt: 2, mb: 0.5 }}>
          Password
        </Typography> */}
        <TextField
          placeholder="Password"
          id="filled-size-normal"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          variant="outlined"
          fullWidth
          size="small"
          sx={{
            "& .MuiInputBase-root": {
              borderRadius: 3,
            },
            mt: 2,
            zIndex: 2,
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={`-ml-1`}>
                <LockIcon className={`${loginStyles.icon_size}`} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end" className={`-ml-1`}>
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {/* "Keep me signed in" checkbox */}
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              onChange={(e) => setRememberMe(e.target.checked)}
              name="rememberMe"
            />
          }
          label="Keep me signed in"
          sx={{ mt: 1, display: "block", marginLeft: "2px", zIndex: 2 }}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            mt: 2,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            type="submit"
            sx={{ borderRadius: 10, width: "50%", fontWeight: 600, zIndex: 2 }}
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? (
              <>
                <CircularProgress size={24} color="inherit" /> &nbsp;
              </>
            ) : (
              "Login"
            )}
          </Button>
        </Box>
      </form>

      {/* Image at the bottom */}
      <Box
        sx={{
          position: "absolute",
          bottom: 4,
          left: "50%",
          transform: "translateX(-50%)",
          width: "100%",
        }}
      >
        <img
          src={mobileBackground} // Replace with your image path
          alt="Login Illustration"
          style={{ width: "100%", objectFit: "contain" }}
        />
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        color={severity}
        message={message}
      />
    </Container>
  );
};

export default MobileLogin;
